<div class="custom-header">
	<span (click)="toggleGroup()" class="expand-collapse-arrow">
		<svg class="icon-10" *ngIf="!isExpanded">
			<use href="../App_Themes/CXone/icons/arrow-right.svg#arrow-right"></use>
		</svg>
		<svg class="icon-10" *ngIf="isExpanded">
			<use href="../App_Themes/CXone/icons/arrow-down.svg#arrow-down"></use>
		</svg>
	</span>
	<span class="display-name">{{params.displayName}}</span>
</div>